import { Helmet } from 'react-helmet-async';
// @mui
import { Button,  Container, Grid, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { Field, Form, Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import {getDownloadURL, getStorage, ref, uploadBytes} from 'firebase/storage'
import { useNavigate } from 'react-router-dom';
import { addDoc, collection, doc, updateDoc } from 'firebase/firestore';
import { LoadingButton } from '@mui/lab';
import vendorCategories  from '../../_mock/categories';
import { auth, db } from '../../firebase';

function AddBusiness() {
const storage = getStorage()
    const data = null
    const navigate = useNavigate()
    const [docId, setdoc] = useState(null)
const [loading, setloading] = useState(false)
const [images, setImages] = useState([]);
const [uploading, setUploading] = useState(false);
const [progress, setProgress] = useState();

const provinces = [
    "Central",
    "Copperbelt",
    "Eastern",
    "Luapula",
    "Lusaka",
    "Muchinga",
    "Northern",
    "North-Western",
    "Southern",
    "Western"
  ];

const initialValues = {      
    name: data?.name,
    phone: data?.phoneNumber,    
    tags: data?.tags ? data.tags.join(", ") : "", 
    province: data?.province,      
    address: data?.address,  
    category : data?.category,
    description : "",
    companyType: ""
  };

  const validationSchema = Yup.object().shape({
       name: Yup.string().required("Name is required"),
       province: Yup.string().required("Province is required"),
       phone: Yup.number().required("Phone Number is required"),
       address: Yup.string().required("Address is required"),
       category: Yup.string().required("Category is required"),
       description: Yup.string().required("Description is required"),
       companyType: Yup.string().required("Company Type is required"),
  });  
  
  const saveProfile = () =>{
    setloading(true)
    handleUpload()
 }

 const handleUpload = () => {
   
  if (images.length === 0) {
    alert("select an image to upload")
    // No image selected
    return;
  }

  const image = images[0];
  uploadImage(image)
  setUploading(true);
  setProgress(0);
 
 
};

const uploadImage = async (image) => {    
      const storageRef = ref(storage, `business/${image.name}`);

      uploadBytes(storageRef, image).then((snapshot) => {
        console.log('Uploaded a blob or file!', snapshot);
        getDownloadURL(snapshot.ref).then(async (downloadURL) => {
            console.log('File available at', downloadURL);
            const userDocRef = doc(db, 'business', docId);
             doc(db, 'business', docId);
                    await updateDoc(userDocRef, {
                    cover_image: downloadURL,
                    });
          });
          setloading(false)
          navigate(-1)
      });
};


const handleImageChange = (event) => {
  if (event.target.files && event.target.files.length > 0) {
    const file = event.target.files[0];
    setImages([file]);
  }
};

  return (
    <>
      <Helmet>
        <title> Add Business</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Add Business
          </Typography>      
         
        </Stack>

                <Grid container>
                    <Grid item xs={12} md={6}>
                    {!docId && <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values,  { resetForm }) => {
                            setloading(true)
                        console.log(values);
                        const docRef = await addDoc(collection(db, "business"),  {...values, tags : values.tags.split(", "), userId : auth.currentUser.uid, createdAt : Date.now()});
                        setdoc(docRef.id)
                            console.log("Document written with ID: ", docRef.id);
                            setloading(false)
                                    }}
                    >
                        {(formik) => (
                        <Form>
                        
                            <Field
                            fullWidth
                            as={TextField}
                            type="text"
                            name="name" 
                            label="Business/Company Name"
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                            /> <br/><br/>
                            <Field
                            fullWidth  multiline
                            as={TextField}
                            name="description"              
                            label="Description"
                            error={formik.touched.description && Boolean(formik.errors.description)}
                            helperText={formik.touched.description && formik.errors.description}
                            /> <br/><br/>
                            <Field
                            fullWidth 
                            as={TextField}
                            name="phone"              
                            label="Phone Number"
                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                            helperText={formik.touched.phone && formik.errors.phone}
                            /> <br/><br/>
                                  <Field
                            fullWidth 
                            as={TextField}
                            name="companyType"
                            select
                            label="Company Type"
                            error={formik.touched.companyType && Boolean(formik.errors.companyType)}
                            helperText={formik.touched.companyType && formik.errors.companyType}
                            > 
                          
                            <MenuItem value={"COMPANY"}>COMPANY</MenuItem>
                            <MenuItem value={"SELF_EMPLOYED"}>SELF EMPLOYED</MenuItem>
              
                            </Field> <br/><br/>
                            <Field
                            fullWidth 
                            as={TextField}
                            name="province"
                            select
                            label="Province"
                            error={formik.touched.province && Boolean(formik.errors.province)}
                            helperText={formik.touched.province && formik.errors.province}
                            > 
                            {provinces.map((c, index)=>(
                            <MenuItem value={c} key={index}>{c}</MenuItem>
                    ))}
                            </Field> <br/><br/>
                    
                            <Field
                            fullWidth 
                            as={TextField}
                            name="category"
                            select
                            label="Category"
                            error={formik.touched.category && Boolean(formik.errors.category)}
                            helperText={formik.touched.category && formik.errors.category}
                            > 
                            {vendorCategories.map((c, index)=>(
                            <MenuItem value={c.category} key={index}><Stack>
                                <Typography>{c.category}</Typography>
                            </Stack></MenuItem>
                    ))}
                            </Field> <br/><br/>
                    
                            <Field
                            fullWidth 
                            as={TextField}
                            name="address"
                                label="Address"
                            error={formik.touched.address && Boolean(formik.errors.address)}
                            helperText={formik.touched.address && formik.errors.address}
                            /> <br/><br/>   
                                
                                <Field
                            fullWidth 
                            as={TextField}
                            name="tags"
                                label="Services (separated by commas)"
                            error={formik.touched.tags && Boolean(formik.errors.tags)}
                            helperText={formik.touched.tags && formik.errors.tags}
                            /> <br/><br/>         

                                {loading ? <Typography>Updating profile</Typography> : 
                                <LoadingButton loading={loading} variant='contained'   size={"large"} color="success" disabled={!formik.isValid} type='submit'>Next</LoadingButton>   }
                
                            </Form>
                        )}
                            </Formik> }

                            {docId && <Stack>
            <Typography variant="overline">Update Profile Image</Typography>
            <br/>
            <br/>
            <Stack direction={"row"} spacing={3}  >
          {data?.profile_image &&  <img  width={123} src={data?.profile_image} style={{objectFit:"cover", borderRadius:"12px"}} height={123} alt='_profile_image'/>}
          <br/>
          <Stack >

          <input type="file"   onChange={handleImageChange} />
           <br/>
                  <LoadingButton
                  loading={loading}
             color="success"
                variant="contained"
                onClick={()=>saveProfile()}
                  >
                Complete
              </LoadingButton>
          </Stack>
          </Stack>     
          </Stack>}
                    </Grid>
                </Grid> 
      </Container>
    </>
  )
}

export default AddBusiness